import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import '../styles/LoginPage.css';
import logo from '../assets/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();
    const { t } = useTranslation();

    // Will hold either email or NID
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const from = location.state?.from?.pathname || "/";

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await login(identifier, password);
            // The navigation is handled inside the login function
            // navigate(from, { replace: true });
        } catch (err) {
            setError('Login failed. Please check your credentials.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <img src={logo} alt="Zakiya Logo" className="login-logo" />
            <h2 className="login-title">{t('login_title')}</h2>
            <p className="login-subtitle">{t('login_subtitle')}</p>
            
            {error && <p className="login-error">{error}</p>}

            <form onSubmit={handleLogin} className="login-form">
                <input 
                    type="text" 
                    placeholder="Email or NID Number" 
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    required 
                />
                <input 
                    type="password" 
                    placeholder="Password" 
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required 
                />
                <button type="submit" disabled={loading}>
                    {loading ? 'Logging in...' : (
                        <>
                            {t('login_button')} <FontAwesomeIcon icon={faArrowRight} />
                        </>
                    )}
                </button>
            </form>
        </div>
    );
};

export default LoginPage;